import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { FIELD_INPUT } from '@/shared/ui-class';
import { cn } from '@/shared/cn';

/**
 * Textarea sibling of `<InputField>`. Same `FIELD_INPUT` surface treatment
 * (divider border, mode-resolved `bg-input` fill).
 */
export type TextareaFieldProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextareaField = forwardRef<HTMLTextAreaElement, TextareaFieldProps>(
  function TextareaField({ className, ...rest }, ref) {
    return (
      <textarea
        ref={ref}
        className={cn('w-full', FIELD_INPUT, className)}
        {...rest}
      />
    );
  },
);
